var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import api from 'app/core/api/api.js';
const initialState = {
    loading: false,
    error: null,
    data: [],
    unreadNotifications: 0,
};
export const fetchNotifications = createAsyncThunk('notifications/fetchAll', (_a, _b) => __awaiter(void 0, [_a, _b], void 0, function* ({ id, params }, { fulfillWithValue, rejectWithValue }) {
    try {
        const response = yield api.users.notifications({ id }, params.queries);
        return fulfillWithValue(response);
    }
    catch (err) {
        return rejectWithValue(err);
    }
}));
export const updateNotification = createAsyncThunk('notifications/update', (notification_1, _a) => __awaiter(void 0, [notification_1, _a], void 0, function* (notification, { fulfillWithValue, rejectWithValue }) {
    try {
        const response = yield api.notifications.update(notification);
        return fulfillWithValue(response);
    }
    catch (err) {
        return rejectWithValue(err);
    }
}));
const { reducer, actions } = createSlice({
    name: 'notifications',
    initialState,
    reducers: {
        incrementUnreadNotifications: (state) => {
            const newCount = state.unreadNotifications ? state.unreadNotifications + 1 : 1;
            state.unreadNotifications = newCount;
        },
        decrementUnreadNotifications: (state) => {
            const newCount = state.unreadNotifications ? state.unreadNotifications - 1 : 0;
            state.unreadNotifications = newCount;
        },
        resetUnreadNotifications: (state) => {
            state.unreadNotifications = 0;
        },
        addNotification: (state, { payload }) => {
            const notification = Object.assign(Object.assign({}, payload), { id: payload.uuid });
            delete notification.uuid;
            state.data = [...state.data, notification];
        },
    },
    extraReducers: (builder) => {
        // FETCH NOTIFICATIONS
        builder.addCase(fetchNotifications.pending, (state) => {
            state.loading = true;
        });
        builder.addCase(fetchNotifications.fulfilled, (state, { payload }) => {
            state.loading = false;
            state.data = payload.results;
            state.unreadNotifications = payload.unread;
        });
        builder.addCase(fetchNotifications.rejected, (state, { payload }) => {
            state.loading = false;
            state.error = payload.error;
        });
        // UPDATE NOTIFICATION
        builder.addCase(updateNotification.pending, (state) => {
            state.loading = true;
        });
        builder.addCase(updateNotification.fulfilled, (state, { payload }) => {
            const newData = [...state.data].map((el) => {
                if (el.id === payload.id) {
                    return payload;
                }
                return el;
            });
            state.data = newData;
            state.loading = false;
        });
        builder.addCase(updateNotification.rejected, (state, { payload }) => {
            state.loading = false;
            state.error = payload.error;
        });
    },
});
export const { incrementUnreadNotifications, decrementUnreadNotifications, resetUnreadNotifications, addNotification } = actions;
export default reducer;
